import { useCallback } from "react";
import apiClient2 from "../../api/apiClient2";
import apiPaths from "../../api/endpoints";

export interface QuestPostPayload {
  id?: number;
  title?: string;
  status: string;
  taskData: { id: number | undefined; title?: string }[];
}

/**
 * Mirrors srcMobile/Screens/FunBoxScreen/QuestScreen/useQuestData.tsx
 *   - retrieveQuestData → GET /retrieveQuest
 *   - postQuestData     → POST /captureQuestResponse
 */
export function useQuestData() {
  const retrieveQuestData = useCallback(async () => {
    try {
      const res = await apiClient2.get(apiPaths.RETRIEVE_QUEST);
      return res;
    } catch (err: any) {
      console.error("retrieveQuestData error:", err);
      return null;
    }
  }, []);

  const postQuestData = useCallback(async (data: QuestPostPayload) => {
    try {
      const res = await apiClient2.post(apiPaths.POST_QUEST, data);
      return res;
    } catch (err: any) {
      console.error("postQuestData error:", err);
      return null;
    }
  }, []);

  return { retrieveQuestData, postQuestData };
}
